export default __webpack_public_path__ + "static/media/pin.71db3189.png";